import React from 'react'
import { observer } from 'mobx-react'
import { Form, Input } from 'components/Form'
import ShadowBox from 'components/ShadowBox'
import Avatar from 'components/Avatar'
import FileButton from 'components/FileButton'

import cx from 'classnames'
import './styles.sass'

export default observer(function ProfileEditor ({ profileEditorStore }) {
  return (
    <div className="profile-editor">
      <div className="avatar-box">
        <FileButton onChange={files => profileEditorStore.uploadPicture(files[0])} accept=".png,.jpg,.jpeg">
          <Avatar
            size={128}
            className="profile-editor-avatar"
            url={profileEditorStore.picture}
          />
        </FileButton>
      </div>
      <ShadowBox className="profile-editor-box">
        <div className="content intro">
          <p>Tell us a little about yourself.</p>
        </div>
        <Form onSubmit={() => profileEditorStore.save()}>
          <div className="columns">
            <div className="column">
              <Input field="firstName" model={profileEditorStore} label="First name" disabled={profileEditorStore.save.pending} />
              <Input field="lastName" model={profileEditorStore} label="Last name" disabled={profileEditorStore.save.pending} />
              <Input field="email" model={profileEditorStore} label="Email address" disabled={profileEditorStore.save.pending || !profileEditorStore.canSetEmail} />
            </div>
          </div>

          <div className="columns">
            <div className="column has-text-centered">
              <button className={cx('button is-awesome', profileEditorStore.save.pending && 'is-loading')} disabled={profileEditorStore.save.pending}>
                Save
              </button>
            </div>
          </div>
        </Form>
      </ShadowBox>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/client/components/ProfileEditor/index.jsx